// User-approved conversation images, deliberately separate from manufacturing.
// This registry authorizes DISPLAY only. It never sets a POD spec orderReady.
export const TEMPORARY_PRODUCT_PHOTOS = Object.freeze(Object.fromEntries([
  ['scorpion-chest-tee', 'front'],
  ['scorpion-back-tee', 'back'],
  ['jellyfish-hem-tee', 'front'],
  ['snake-chest-tee', 'front'],
  ['snake-back-tee', 'back'],
  ['puffer-mug', 'print-surface'],
  ['snake-tumbler', 'print-surface'],
  ['scorpion-chest-hoodie-concept', 'front'],
  ['jellyfish-tote-concept', 'front'],
  ['snake-notebook-concept', 'front'],
].map(([slug, view]) => [slug, Object.freeze({
  slug, view, photo: `/products/concept/${slug}.webp`, source: 'concept',
  approvedForDisplay: true, manufacturingVerified: false,
})])));

// No provider variant is invented for these three visual studies. In particular,
// a natural tote is not assigned to the black tote variant, and the hardcover
// notebook is not assigned to the catalog's spiral notebook.
export const TEMPORARY_PRODUCTS = Object.freeze([
  { slug: 'scorpion-chest-hoodie-concept', name: 'SCORPION CHEST HOODIE',
    productType: 'tee', category: 'tee', catalogGroup: 'APPAREL', color: 'black',
    view: 'front', mascot: 'scorpion', file: 'scorpion-main.png', layout: 'left_chest' },
  { slug: 'jellyfish-tote-concept', name: 'JELLYFISH TOTE',
    productType: 'object', category: 'accessory', catalogGroup: 'HOME', color: 'natural',
    view: 'front', mascot: 'jellyfish', file: 'jellyfish.png', layout: 'center' },
  { slug: 'snake-notebook-concept', name: 'SNAKE NOTEBOOK',
    productType: 'object', category: 'accessory', catalogGroup: 'HOME', color: 'white',
    view: 'front', mascot: 'snake', file: 'snake.png', layout: 'center' },
].map(Object.freeze));
export const temporaryProductFor = slug => TEMPORARY_PRODUCTS.find(p => p.slug === slug) || null;
